var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-inner"},[_c('RichEditor',{attrs:{"inline":true,"block-id":_vm.block.id,"paste-tags":false,"placeholder":"Write a question"},on:{"input":function($event){return _vm.$emit('edit')}},model:{value:(_vm.block.content),callback:function ($$v) {_vm.$set(_vm.block, "content", $$v)},expression:"block.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }